export const BASE_COLOR = 'rgb(245, 245, 245)'; // background color
export const RED = '#c32020'; // red color
export const BLACK = '#212121'; // black color
export const GRAY = '#B6B6B6';
export const BACKGROUND_GRAY = '#F5F5F5';
export const BACKGROUND_FOOTER = '#F8F8F8';
export const LINE_GRAY = '#DEDEDE';
export const YELLOW = '#FFE65D';
export const WHITE = '#FFFFFF';

export const colorArray = [
  '#FE7773',
  '#D1DDDB',
  '#85B8C8',
  '#7FB174',
  '#D3B8D8',
  '#F2DD66',
];
